
import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
/**
 * 
 */

export class UserDelegate
{

    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }


    public updateDefaultOrg(userId: string, orgId: string): Observable<boolean>
    {
        const request = {
            "orgId": orgId,
            "userId": userId,
            "clientTimeStamp": new Date().toISOString()
        };
        return this.http.post(ServiceEndpointConstants.endpoints.USER.UPDATE_ORG_ID, request).pipe(share());
    }
}